import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Address } from '../models/Address';
import { GItem } from '../models/GItem';
import { NotificationService, NotificationSettings } from '@progress/kendo-angular-notification';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { Title } from '@angular/platform-browser';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { BehaviorSubject } from 'rxjs';
import { Message } from '../models/message';
import { environment } from '../../../../environments/environment';
import { CmProAuthService } from '@app/core/services/cmpro-auth.service';

@Injectable({
    providedIn: 'root',
})
export class GlobalsService {

    private _keyPress: BehaviorSubject<KeyboardEvent> = new BehaviorSubject(null);
    public keyPress$: Observable<KeyboardEvent> = this._keyPress.asObservable();
    sendKeyPress(event: KeyboardEvent) {
        this._keyPress.next(event);
    }
    private _message: BehaviorSubject<Message> = new BehaviorSubject(null);
    public message$: Observable<Message> = this._message.asObservable();
    sendMessage(message: Message) {
        this._message.next(message);
    }

    constructor(private svc_not: NotificationService, private cmProAuthService: CmProAuthService, private titleService: Title) {
        this.companyAddress.push(new Address());
        this.companyAddress[0].set("55 Brandon Drive", null, "Glendale Heights", "IL", "60139", "Climate Pros");
    }

    public noteDebounce: number = 1000;
    get user(): UsersBus {
        return this.cmProAuthService.user;
    }
    get userId(): any {
        //we have to guard the user not being here yet
        return this.user?.userid;
    }
    get companyId(): any {
        //we have to guard the user not being here yet
        return this.user?.companyId;
    }
    get personId(): any {
        //we have to guard the user not being here yet
        return this.user?.personId;
    }

    get isProd(): boolean {
        return environment.production;
    }
    get isDevOrStaging(): boolean {
        return environment.devOrStaging;
    }
    static readonly Caption_DialogCloseOk: string = "Close";
    grid_PageSize: number | null = null; //50;
    grid_PageSizePopups: number = 50;
    grid_Pageable: boolean = false;
    grid_PageSize_TimeSheetApproval: number = 25;
    grid_Pageable_TimeSheetApproval: boolean = true;
    grid_PageableOptions: any = { buttonCount: 5, info: true, type: 'numeric', previousNext: true };
    grid_PageSizes: number[] = [10, 25, 50, 100, 250, 500, 1000];
    grid_PageButtonCount: number = 5;
    grid_Sortable: any = true;
    grid_Filterable: any = false;
    grid_Groupable: any = false;
    grid_PdfAllPages: boolean = false;
    dateFormat_MMDDYYYY_HHMM: string = 'MM/dd/yyyy hh:mm a';
    grid_Height: number = 740; //Height of gird if over grid_LineCount = 20
    grid_LineCount: number = 24; //Number of lines in a grid before setting grid_Height

    public genMinDate: Date = new Date(2000, 1, 1);
    public redirectURL: string;

    countries: GItem[] = [
        { "description": "United States", "value": "US", "category": null, "reference": null },
        { "description": "Bahamas", "value": "BS", "category": null, "reference": null },
        { "description": "Barbados", "value": "BB", "category": null, "reference": null },
        { "description": "St. Lucia", "value": "SL", "category": null, "reference": null },
        { "description": "Canada", "value": "CA", "category": null, "reference": null }
    ];

    daysAgedOptions: GItem[] =
        [
            { value: "0", description: "Less than 15 Days", category: null, canSelect: true, reference: null },
            { value: "1", description: "16-30 Days", category: null, canSelect: true, reference: null },
            { value: "2", description: "31-60 Days", category: null, canSelect: true, reference: null },
            { value: "3", description: "61-90 Days", category: null, canSelect: true, reference: null },
            { value: "4", description: "91+ Days", category: null, canSelect: true, reference: null }
        ];

    search_take: number = 100;
    tt_Export: string = "Export creates a (Pdf or Excel) document of the records/items in the selected page. You can change the number of records/items per page using the 'items per page' selector located at the bottom.";
    tt_GridSearch: string = "Type text to filter/search the results in the grid";
    companyAddress: Address[] = [];
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    private _defaultNotificationSettings: NotificationSettings = {
        content: "This is a very long message",
        cssClass: 'cp-notification',
        animation: { type: 'fade', duration: 400 },
        position: { horizontal: "left", vertical: "bottom" },
        type: { style: 'success', icon: true },
        closable: false,
        hideAfter: 3000
    };
    /**
    * @deprecated This notify is deprecated and will be removed in future versions. Please use the specific notify methods
    */
    notify(notification: string, type: string = "S", closable: boolean = null, settings: NotificationSettings = null) {
        switch (type) {
            case "S":
                this.notifySuccess(notification, closable, settings);
                break;
            case "W":
                this.notifyWarning(notification, closable, settings);
                break;
            case "I":
                this.notifyInfo(notification, closable, settings);
                break;
            case "E":
                this.notifyError(notification, closable, settings);
                break;
        }
    }
    notifySuccess(notification: string, closable: boolean = false, settings: NotificationSettings = null) {
        let notifySettings = this.mappingNotifySettings(settings);
        //regardless of passed settings, we want to set these
        notifySettings.content = notification;
        notifySettings.closable = closable;
        notifySettings.type = { style: 'success', icon: true };
        this.svc_not.show(notifySettings);
    }
    private warningNotificationSet = new Set<string>();
    notifyWarning(notification: string, closable: boolean = false, settings: NotificationSettings = null) {
        let notifySettings = this.mappingNotifySettings(settings);
        //regardless of passed settings, we want to set these
        notifySettings.content = notification;
        notifySettings.closable = closable;
        notifySettings.type = { style: 'warning', icon: true };
        if (closable) {
            if (!this.warningNotificationSet.has(notification)) {
                this.warningNotificationSet.add(notification);
                const callback = this.svc_not.show(notifySettings);
                callback.afterHide.subscribe((val) => {
                    this.warningNotificationSet.delete(notification);
                });
            }
        } else {
            this.svc_not.show(notifySettings);
        }
    }
    notifyInfo(notification: string, closable: boolean = false, settings: NotificationSettings = null) {
        let notifySettings = this.mappingNotifySettings(settings);
        //regardless of passed settings, we want to set these
        notifySettings.content = notification;
        notifySettings.closable = closable;
        notifySettings.type = { style: 'info', icon: true };
        this.svc_not.show(notifySettings);
    }

    private errorNotificationSet = new Set<string>();
    notifyError(notification: string, closable: boolean = false, settings: NotificationSettings = null) {
        let notifySettings = this.mappingNotifySettings(settings);
        //regardless of passed settings, we want to set these
        notifySettings.content = notification;
        notifySettings.closable = closable;
        notifySettings.type = { style: 'error', icon: true };
        if (closable) {
            if (!this.errorNotificationSet.has(notification)) {
                this.errorNotificationSet.add(notification);
                const callback = this.svc_not.show(notifySettings);
                callback.afterHide.subscribe((val) => {
                    this.errorNotificationSet.delete(notification);
                });
            }
        } else {
            this.svc_not.show(notifySettings);
        }
    }

    /**
     * This method is used to map the passed settings to the default settings.
     *
     * We only allow override of certain properties, the rest are set to the default values.
     *
     * @private
     * @param {NotificationSettings} [settings=null]
     * @return {*}  {NotificationSettings}
     * @memberof GlobalsService
     */
    private mappingNotifySettings(settings: NotificationSettings = null): NotificationSettings {
        let notifySettings = { ...this._defaultNotificationSettings };

        if (settings?.cssClass) {
            notifySettings.cssClass = `${notifySettings.cssClass} ${settings.cssClass}`;
        }

        if (settings?.hideAfter > 0) {
            notifySettings.hideAfter = settings.hideAfter;
        }

        if (settings?.animation) {
            notifySettings.animation = settings.animation;
        }
        return notifySettings;
    }

    public setTitle(newTitle: string) {
        if (newTitle.length > 0) {
            this.titleService.setTitle('FJX - ' + newTitle);
        } else {
            this.titleService.setTitle('FieldJetX');
        }
    }
}
